module.exports = __webpack_public_path__ + "img/128x128_star_home.0ab8bd60.svg";